import React from 'react';
import { Routes, Route } from 'react-router-dom';

import responsavelLeadRoutes from './app.responsavellead.nav.routes';
import authRoutes from './auth.nav.routes';

const AppResponsavelLeadRoutes = () => (
  <Routes>
    {responsavelLeadRoutes.map(({ path, Component }, index) => (
      <Route key={index} path={path} element={<Component />} />
    ))}
    {authRoutes.map(({ path, Component }, index) => (
      <Route key={index} path={path} element={<Component />} />
    ))}
  </Routes>
);

export default AppResponsavelLeadRoutes;
